// extracted by mini-css-extract-plugin
export default {"cls1":"ProfileBulkFollowModal-cls1_CwG","cls2":"ProfileBulkFollowModal-cls2_dry ProfileBulkFollowModal-cls1_CwG"};